module.exports = __webpack_public_path__ + "static/media/YF31_1.a7bf709e.jpg";